import booleanPointInPolygon from '@turf/boolean-point-in-polygon'
import distance from '@turf/distance'
import { point } from '@turf/helpers'

function parseGeoJson(geojson) {
    if (!geojson) return null

    if (typeof geojson === 'string') {
        try {
            return JSON.parse(geojson)
        } catch (e) {
            return null
        }
    }

    return geojson
}

function getPolygonFeatures(geojson) {
    const parsed = parseGeoJson(geojson)
    if (!parsed) return []

    if (parsed.type === 'FeatureCollection') {
        return (parsed.features || []).filter((feature) =>
            ['Polygon', 'MultiPolygon'].includes(feature?.geometry?.type)
        )
    }

    if (parsed.type === 'Feature') {
        return ['Polygon', 'MultiPolygon'].includes(parsed.geometry?.type) ? [parsed] : []
    }

    return ['Polygon', 'MultiPolygon'].includes(parsed.type)
        ? [{ type: 'Feature', properties: {}, geometry: parsed }]
        : []
}

function isValidCoordinate(value) {
    return value !== null && value !== '' && Number.isFinite(Number(value))
}

export function isPointInsidePoi(lat, lng, poi) {
    if (!isValidCoordinate(lat) || !isValidCoordinate(lng) || !poi) return false

    const truckPoint = point([Number(lng), Number(lat)])
    const isPolygon = poi.area_type === 'polygon' || !!poi.polygon_geojson

    if (isPolygon) {
        try {
            return getPolygonFeatures(poi.polygon_geojson).some((polygon) =>
                booleanPointInPolygon(truckPoint, polygon)
            )
        } catch (e) {
            return false
        }
    }

    if (
        !isValidCoordinate(poi.lat) ||
        !isValidCoordinate(poi.lng) ||
        !Number.isFinite(Number(poi.radius)) ||
        Number(poi.radius) < 0
    ) {
        return false
    }

    const center = point([Number(poi.lng), Number(poi.lat)])
    const distanceInMeters = distance(truckPoint, center, { units: 'kilometers' }) * 1000

    return distanceInMeters <= Number(poi.radius)
}
